import FollowUpRule from './FollowUpRule';
import RenderMode from './RenderMode';
import SurveyChoiceOption from './SurveyChoiceOption';
import SurveyQuestion from './SurveyQuestion';
import SurveyQuestionType from './SurveyQuestionType';

class SurveyQuestionMultipleChoice extends SurveyQuestion {
  options: SurveyChoiceOption[];

  allowMultiSelect: boolean;

  renderMode: RenderMode;

  constructor(
    questionId: string,
    questionType: SurveyQuestionType,
    title: string,
    description: string,
    group: string,
    variability: string,
    identifier: string,
    options: SurveyChoiceOption[],
    allowMultiSelect: boolean,
    renderMode: RenderMode,
    followUpRules: FollowUpRule[],
    imageIdentifier: string,
    info?: string,
    suffix?: string,
    allowSkipWithDefaultValue?: boolean
  ) {
    super(
      questionId,
      questionType,
      title,
      description,
      group,
      variability,
      identifier,
      followUpRules,
      imageIdentifier,
      info,
      suffix,
      allowSkipWithDefaultValue
    );

    this.options = options;
    this.allowMultiSelect = allowMultiSelect;
    this.renderMode = renderMode;
  }

  public static parse(object: any) {
    return new SurveyQuestionMultipleChoice(
      object.QuestionId,
      object.QuestionType,
      object.Title,
      object.Description,
      object.Group,
      object.Variability,
      object.Identifier,
      object.Options.map((option: {}) => SurveyChoiceOption.parse(option)),
      object.AllowMultiSelect,
      object.RenderMode,
      object.FollowUpRules.map((rule: {}) => FollowUpRule.parse(rule)) ?? [],
      object.ImageIdentifier,
      object.Info ?? undefined,
      object.Suffix ?? undefined,
      object.AllowSkipWithDefaultValue ?? undefined
    );
  }
}

export default SurveyQuestionMultipleChoice;
